import axios from './axios';

export default {
  verify: async body => {
    const { data } = await axios.post('/member-ofs/verify', body);
    return data;
  },

  inviteExistingUser: async body => {
    const { data } = await axios.post(
      '/member-ofs/create-for-existing-user',
      body
    );
    return data;
  },

  inviteNewUser: async (_, body) => {
    const { data } = await axios.post('/member-ofs/create-for-new-user', body);
    return data;
  },

  getByToken: async token => {
    const { data } = await axios.get(`/member-ofs/${token}`);
    return data;
  },

  updateStatus: async (token, status, query) => {
    const params = { params: query };
    const { data } = await axios.get(`/member-ofs/${token}/${status}`, params);
    return data;
  },

  updatePermission: async (id, body) => {
    const { data } = await axios.put(`/member-ofs/${id}`, body);
    return data;
  },

  deleteFromProject: async id => {
    const { data } = await axios.delete(`/member-ofs/${id}`);
    return data;
  },

  selfRegistrationExsistingUser: async body => {
    const { data } = await axios.post(
      '/member-ofs/self/create-for-existing-user',
      body
    );

    return data;
  },

  selfRegistrationNewUser: async body => {
    const { data } = await axios.post(
      '/member-ofs/self/create-for-new-user',
      body
    );
    return data;
  },

  newRoleRequest: async (id, body) => {
    const { data } = await axios.post(`/member-ofs/${id}/role-request`, body);
    return data;
  },

  resendInvitation: async id => {
    const { data } = await axios.post(`/member-ofs/${id}/resend-invite`);
    return data;
  },

  reassign: async (id, body) => {
    const { data } = await axios.put(`/member-ofs/${id}/reassign`, body);
    return data;
  },

  resendToken: async id => {
    const { data } = await axios.post(
      `/member-ofs/${id}/resend-direct-registration-email`
    );
    return data;
  }
};
